import {
  additionalDonationInfoSchema,
  AdditionalDonationInfoSchemaType,
} from 'modules/donations/components/AdditionalDonationInfoForm/schema';
import {
  vitalsSectionSchema,
  VitalsSectionSchemaType,
} from 'modules/donations/components/CreateDonationForm/VitalsSection/schema';
import { ineligibleReasonSchema } from 'modules/donations/schemas';
import * as yup from 'yup';

type CreateDonationSchemaType = {
  vitalsSection: VitalsSectionSchemaType;
  additionalInfoSection: AdditionalDonationInfoSchemaType;
};

const normalDonationSchema = yup.object({
  vitalsSection: vitalsSectionSchema,
  additionalInfoSection: additionalDonationInfoSchema,
});

const ineligibleDonationOverride: yup.AnyObjectSchema = yup.object({
  vitalsSection: yup.object({
    examination: yup.object({
      ineligibleReason: ineligibleReasonSchema,
      ineligibleReasonDetails: yup.string().optional().nullable(),
    }),
  }),
});

const createDonationSchema = yup.lazy((values: CreateDonationSchemaType) =>
  values?.vitalsSection?.examination?.ineligible
    ? ineligibleDonationOverride
    : normalDonationSchema
);

export { createDonationSchema };
export type { CreateDonationSchemaType };
